var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "input-wrapper" },
    [
      _c("input", {
        staticClass: "text-input defaultInputBorder",
        attrs: {
          id: "rest-search-input",
          type: "text",
          placeholder: _vm.placeholder,
          "aria-label": _vm.placeholder,
        },
        on: {
          input: function ($event) {
            return _vm.$emit("input", $event.target.value)
          },
        },
      }),
      _vm._v(" "),
      _c(
        "icon-base",
        {
          staticClass: "input-icon",
          attrs: {
            width: "25px",
            height: "25px",
            iconName: "Search Restaurants",
            id: "searchRestaurants",
          },
        },
        [_c("icon-search")],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }